import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { capitalizeFirstLetter } from '../Shared/Helpers';
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepFive = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState(null);

    useEffect(() => {
        window.scrollTo(0, 0);
        if (storedData) {
            setFormData(storedData?.payslipPassword);
        } else {
            console.log("storedData is empty");
        }
    }, []);

    const validateForm = (formData) => {
        const { employeeName, email, password } = formData;
        const errors = {
            employeeName: isEmpty(employeeName) && 'Employee name is required',
            email: validateEmail(email),
            password: validatePassword(password),
        };
        return errors;
    }

    const validateEmail = email => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (isEmpty(email)) return 'Email name is required';
        if (!emailRegex.test(email)) {
            return 'Invalid email format';
        }
        return null
    }

    const validatePassword = (password) => {
        if (password?.length < 9) {
            return 'Password must contain more than 8 characters.';
        }
        if (!/[a-z]/.test(password)) {
            return 'Password must include at least one lowercase letter.';
        }
        if (!/[A-Z]/.test(password)) {
            return 'Password must include at least one uppercase letter.';
        }
        if (!/\d/.test(password)) {
            return 'Password must contain more at least one number.';
        }

        return null;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);
            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitPayslipPassword?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                    body: JSON.stringify(formData),
                });
                if (response.status === 200) {
                    handleNext({ payslipPassword: formData });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >5. Payslip Password</h2>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5>The method of delivering payslips to employees will be by Electronic Secure PDF Format. Under this format your payslip will be emailed directly to an email address of your choice.</h5></span>
                <span><h5>The payslip will be sent as a secure PDF document that must be password protected and, given that this is a sensitive document the Company will be using SAGE Payroll to generate this email.</h5></span>
            </Col>

            <Col sm={12} className="my-1">
                <h5 className="">Employee Name:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="text"
                        value={formData?.employeeName}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                employeeName: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.employeeName ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.employeeName && <Form.Text className="text-danger"> <span className="star">*</span> {errors.employeeName} </Form.Text>}
                </Form.Group>
            </Col>
            <Col sm={12} className="my-1">
                <h5 className="">Email Address where the payslip should be sent:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="email"
                        value={formData?.email}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                email: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.email ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.email && <Form.Text className="text-danger"> <span className="star">*</span> {errors.email} </Form.Text>}
                </Form.Group>
            </Col>
            <Col sm={12} className="my-1">
                <h5 className="">Secure Password:<span className="star">*</span></h5>
                <Form.Group>
                    <Form.Control type="password"
                        value={formData?.password}
                        onChange={(e) => {
                            const updatedValue = e.target.value;
                            setFormData(prevState => ({
                                ...prevState,
                                password: capitalizeFirstLetter(updatedValue),
                            }));
                        }}
                        className={errors.password ? "form-control is-invalid custom-input" : "form-control custom-input"}
                    />
                    {errors.password && <Form.Text className="text-danger"> <span className="star">*</span> {errors.password} </Form.Text>}
                </Form.Group>
            </Col>

            <Col sm={12} md={12}>
                <span><h5>Please note when choosing your secure password, this will be a password that is strictly between you and me and should always be kept confidential. To ensure that the passwords are strong I have insisted on the following password creation rules:</h5></span>
                <div className='d-flex justify-content-start'>
                    <ul >
                        <li><h5>Password must contain more than 8 characters</h5></li>
                        <li><h5>Password must have a combination of lower and UPPERCASE Letters</h5></li>
                        <li><h5>Password must contain at least 1 number</h5></li>
                        <li><h5>Password should be a unique combination of the above and only apply to FP McCann payroll, and not one you currently use for any personal security online</h5></li>
                    </ul>
                </div>
            </Col>

            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepFive;




// Details ~ // Please Provide
// Employee Name
// Email Address where the payslip should be sent
// Secure Password

